// Metres across the image — the unit a printed map is judged in, and one a zoom number cannot
// state alone. mapbox's 512px world tile puts its zoom a step ahead of the 256px-tile formula.
const EARTH_CIRCUMFERENCE_M = 40030229
const WORLD_TILE_PX = 512

const worldMetresAt = (latitude: number): number =>
  EARTH_CIRCUMFERENCE_M * Math.cos((latitude * Math.PI) / 180)

export const metresPerPixel = (zoom: number, latitude: number): number =>
  worldMetresAt(latitude) / (WORLD_TILE_PX * 2 ** zoom)

export const spanForZoom = (
  zoom: number,
  latitude: number,
  widthPx: number,
): number => widthPx * metresPerPixel(zoom, latitude)

export const zoomForSpan = (
  spanM: number,
  latitude: number,
  widthPx: number,
): number =>
  Math.log2((worldMetresAt(latitude) * widthPx) / (WORLD_TILE_PX * spanM))
